<path
    d="M6.19045 21.854C5.69432 22.211 5.00244 21.8564 5.00244 21.2452V6.24927C5.00244 4.45434 6.45752 2.99927 8.25244 2.99927H15.7508C17.5458 2.99927 19.0008 4.45434 19.0008 6.24927V21.2452C19.0008 21.8564 18.309 22.211 17.8128 21.854L12.0016 17.6731L6.19045 21.854Z"
    fill="currentColor"
/>
